// extracted by mini-css-extract-plugin
export default {"myFavorites":"favourites_myFavorites__S-DrV","show":"favourites_show__fJ8J7","favoriteContainer":"favourites_favoriteContainer__GYrxZ"};